/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Enforcement_CityInputs */

const en_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const de_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const fr_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const es_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const it_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const nl_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const pl_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const fi_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const da_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

const sv_a11y_statement_enforcement_city = /** @type {(inputs: A11y_Statement_Enforcement_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`39114 Magdeburg`)
};

/**
* | output |
* | --- |
* | "39114 Magdeburg" |
*
* @param {A11y_Statement_Enforcement_CityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_enforcement_city = /** @type {((inputs?: A11y_Statement_Enforcement_CityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Enforcement_CityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_enforcement_city(inputs)
	if (locale === "fr") return fr_a11y_statement_enforcement_city(inputs)
	if (locale === "es") return es_a11y_statement_enforcement_city(inputs)
	if (locale === "it") return it_a11y_statement_enforcement_city(inputs)
	if (locale === "nl") return nl_a11y_statement_enforcement_city(inputs)
	if (locale === "pl") return pl_a11y_statement_enforcement_city(inputs)
	if (locale === "fi") return fi_a11y_statement_enforcement_city(inputs)
	if (locale === "da") return da_a11y_statement_enforcement_city(inputs)
	if (locale === "sv") return sv_a11y_statement_enforcement_city(inputs)
	return en_a11y_statement_enforcement_city(inputs)
});